import React, { memo, useEffect, useMemo, useState } from "react";
import moment from "moment";
import { Grid, Icon, Label, Popup, Image } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";
import { displayGender } from "utils/displayGender";
import displayName from "utils/displayName";
import FastResultInfo from "./FastResultInfo";
import TubeWithTimerInfo from "./TubeWithTimerInfo";
import WaitingTimeInfo from "./WaitingTimeInfo";
import { PrescriptionsDocumentViewer } from "./PrescriptionDocumentViewer/PrescriptionsDocumentViewer";
//TO TRANSLATE
const _appointmentContainer = (status, shouldOpen, urgent) => ({
	backgroundColor:
		status === "DONE"
			? "rgba(66, 179, 158, 0.4)"
			: status === "CANCELED"
			? "rgba(145,166,180, 0.4)"
			: urgent
			? "rgba(255, 80, 77,0.4)"
			: shouldOpen
			? "rgba(253, 253, 150,0.4)"
			: "#fff",
	width: "100%",
	position: "relative",
	padding: 10,
	display: "flex",
	borderRadius: "0",
	marginTop: "5px",
	boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
	alignItems: "center",
});
const PrescriptionsDocumentViewerMemo = memo(PrescriptionsDocumentViewer);

const FolderCard = ({
	labAppointment,
	folder,
	index,
	generalParameters,
	user,
	openFolder,
	selectPatient,
	appointmentToOpen,
	t,
	fastResultTube,
	displayCenter,
	displayBox,
	withAliquot,
	maxMinutesForAliquot,
	doneFolderHelp,
	openFilesModal,
	getAllPrescriptionScans,
	showIdentityVigilancePopUp,
}) => {
	const folderMemo = useMemo(() => folder, [folder]);
	const [hasScans, setHasScans] = useState(false);
	const [showScansModal, setShowScansModal] = useState(false);
	const isFastLinePatient = labAppointment?.patient?.first_name === "Register" && labAppointment?.patient?.birth_name === "Line";

	useEffect(() => {
		setHasScans(false);
		if (folder?.prescriptions && folder.prescriptions.length > 0) {
			for (const prescription of folder.prescriptions) {
				if (prescription.hasScans) setHasScans(true);
			}
		}
	}, [setHasScans, folder]);

	const closeDocumentViewer = () => {
		setShowScansModal(false);
	};
	const colors = ["red", "orange", "yellow", "olive", "green", "blue", "violet", "purple", "pink", "brown", "grey", "black"];
	const getCentercolor = (id) => colors[id % 12];

	const isUrgent = folder && folder.prescriptions.findIndex((prescri) => prescri.urgent) > -1;

	const getAnalysesString = (folder) => {
		let analyses = [];
		let analysesStr = "";

		if (folder && folder.prescriptions) {
			folder.prescriptions.forEach((presc) => {
				if (presc && presc.analyses)
					presc.analyses.forEach((ana) => {
						if (ana && ana.properties && ana.properties.code && !analyses.includes(ana.properties.code)) analyses.push(ana.properties.code);
					});
			});
			analyses.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
			analysesStr = analyses.reduce((a, b) => a.concat(b + ", "), "");
			analysesStr = analysesStr.substr(0, analysesStr.length - 2);
		}
		return analysesStr;
	};

	const getPrescriberString = (folder) => {
		let prescribersStr = "";
		let prescribers = [];
		if (folder && folder.prescriptions) {
			folder.prescriptions.forEach((presc) => {
				if (presc && presc.prescriber) prescribers.push(`${presc.prescriber.title} ${presc.prescriber.last_name} ${presc.prescriber.first_name}`);
			});
			prescribers.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
			prescribersStr = prescribers.reduce((a, b) => a.concat(b + ", "), "");
			prescribersStr = prescribersStr.substr(0, prescribersStr.length - 2);
		}
		return prescribersStr;
	};

	const folderHasNewTubes = (folder) => {
		if (!folder || !folder.prescriptions || !folder.prescriptions.some((p) => p.tubes)) return false;
		for (const presc of folder.prescriptions) {
			for (const tube of presc.tubes) {
				if (tube.status === "NEW") return true;
			}
		}

		return false;
	};

	return (
		<Grid.Row
			key={"appointment" + index}
			style={_appointmentContainer(labAppointment?.status, labAppointment && appointmentToOpen === labAppointment?.id, isUrgent)}
		>
			<Grid.Column mobile={16} tablet={5} computer={5} style={{ paddingLeft: 20 }}>
				{displayCenter && labAppointment.center && (
					<Label as="span" color={getCentercolor(labAppointment.center.id)} ribbon>
						{labAppointment.center.name} {labAppointment.box && displayBox ? ` - Box ${labAppointment.box.name}` : ""}
					</Label>
				)}
				{!displayCenter && !displayBox && labAppointment.box && (
					<Label as="span" color={getCentercolor(labAppointment.box.id)} ribbon>
						{`Box ${labAppointment.box.name}`}
					</Label>
				)}
				{folder?.status === "HELP_NURSE" && folder.folderHelp && (
					<Label as="span" color="orange">
						Télésecrétariat
					</Label>
				)}
				{folder?.is_express && (
					<Label as="span" color="purple">
						Dépôt express
					</Label>
				)}

				<div style={{ paddingLeft: 20, position: "relative" }}>
					<div
						style={{
							width: 10,
							height: 10,
							borderRadius: "5px",
							position: "absolute",
							left: "-10px",
							top: 25,
							backgroundColor: labAppointment?.analysis_color,
						}}
					></div>
					{(labAppointment.patient.id === +process.env.REACT_APP_USER_TO_CHANGE || isFastLinePatient) && <div>Patient à associer</div>}
					{labAppointment.patient.id !== +process.env.REACT_APP_USER_TO_CHANGE && !isFastLinePatient && (
						<>
							<div>
								{displayGender(labAppointment?.patient ?? folder?.patient, generalParameters?.data)}{" "}
								{displayName(labAppointment?.patient ?? folder?.patient)}
							</div>
							<div style={{ fontSize: "0.8em" }}>CNS: {labAppointment?.patient?.cns ?? folder?.patient?.cns ?? "/"}</div>
							{(labAppointment?.patient?.birth_date || folder?.patient?.birth_date) && (
								<div style={{ fontSize: "0.8em", fontStyle: "italic" }}>
									{moment().diff(labAppointment?.patient?.birth_date ?? folder?.patient?.birth_date ?? "/", "years")} ans
								</div>
							)}
						</>
					)}
				</div>
			</Grid.Column>

			<Grid.Column
				mobile={16}
				tablet={5}
				computer={5}
				style={{
					width: "30%",
					marginTop: 0,
				}}
			>
				{folder && (
					<div>
						<div style={{ fontSize: "0.8em", display: "flex" }}>
							Dossier {folder.code}{" "}
							{labAppointment &&
								`- créé à ${moment(labAppointment._date + "T" + labAppointment._time).format(process.env.REACT_APP_TIME_DISPLAY_FORMAT)}`}
						</div>

						{getPrescriberString(folder) !== "" && <div style={{ fontSize: "0.8em", fontStyle: "italic" }}>{getPrescriberString(folder)}</div>}
						<div style={{ fontSize: "0.7em" }}>{getAnalysesString(folder)}</div>
						<div style={{ fontSize: "0.8em" }}>
							{folder.status === "HELP_NURSE" && folder.paused_at && (
								<>
									<Icon name="bell" style={{ color: "darkorange" }} />
									{`Télésecrétariat : Dossier prêt à prélever depuis le ${moment(folder.paused_at).format(
										`${process.env.REACT_APP_DATE_DISPLAY_FORMAT} [à] ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
									)}`}
								</>
							)}
							{folder.status === "DONE" && (
								<>
									<Icon name="check" style={{ color: "#2A2982" }} /> Dossier terminé
								</>
							)}
							{folder.status === "CANCELED" && (
								<>
									<Icon name="cancel" style={{ color: "#DC143C" }} /> Dossier annulé
								</>
							)}
							{folder.status === "NEW" && isUrgent && (
								<>
									<Icon name="warning" style={{ color: "#ff0000" }} /> Dossier urgent
								</>
							)}
						</div>
					</div>
				)}
			</Grid.Column>
			<Grid.Column mobile={16} tablet={3} computer={3} style={{ width: "20%", textAlign: "right" }}>
				{folder &&
					withAliquot &&
					folder.prescriptions.some(
						(p) =>
							p.tubes &&
							p.tubes.length > 0 &&
							p.analyses &&
							p.analyses.length > 0 &&
							p.analyses
								.filter((a) => a.properties.pretreatment_stability <= maxMinutesForAliquot)
								.filter(
									(a) =>
										a.tubes &&
										a.tubes.length > 0 &&
										a.tubes
											.map((t) => t.id)
											.some((id) =>
												p.tubes
													.filter((t) => t.properties.aliquot && !t.provider_barcode)
													.map((t) => t.id)
													.includes(id)
											)
								).length > 0
					) &&
					folder.status !== "CANCELED" &&
					folder.status !== "DONE" && (
						<div style={{ width: "100%", textAlign: "center", color: "teal" }}>
							<Icon name="wait" />
							<Icon name="lab" /> <span>Aliquot(s) à réaliser </span>
						</div>
					)}
				{folder &&
					fastResultTube &&
					folder.status !== "CANCELED" &&
					folder.status !== "DONE" &&
					folder.prescriptions &&
					!folder.prescriptions.some((p) => p.safeplace_result) && <FastResultInfo tube={fastResultTube} t={t} />}
				{folder &&
					folder.status !== "CANCELED" &&
					folder.status !== "DONE" &&
					folder.prescriptions &&
					folder.prescriptions.some((p) => p.tubes && p.tubes.some((t) => t.status === "NEW" && t.properties.timer > 0)) && (
						<TubeWithTimerInfo tubes={folder.prescriptions.flatMap((p) => p.tubes)} t={t} />
					)}
				{folder &&
					folder.status !== "CANCELED" &&
					folder.status !== "DONE" &&
					folder.prescriptions &&
					folder.prescriptions.some(
						(p) =>
							p.analyses &&
							p.analyses.some((a) => a.properties.waiting_time_before_sampling > 0 && a.tubes && a.tubes.some((t) => t.status === "NEW"))
					) &&
					folder.prescriptions.some((p) => p.tubes && p.tubes.some((t) => t.status === "NEW")) && (
						<WaitingTimeInfo
							creation_date={labAppointment._date + " " + labAppointment._time}
							analyses={folder.prescriptions.flatMap((p) => p.analyses)}
							t={t}
						/>
					)}
				{folder && !!folder.deposit && (
					<Popup
						content="Dépôt"
						position="right center"
						trigger={
							<div style={{ display: "flex", alignContent: "baseline" }}>
								<Image src={window.location.origin + "/icones/depot.svg"} height="15" /> Dépôt
							</div>
						}
					/>
				)}
			</Grid.Column>
			<Grid.Column mobile={16} tablet={3} computer={3} style={{ width: "20%", textAlign: "right" }}>
				{user?.session?.rights === "ADMIN" && folder?.status === "CANCELED" && (
					<MainButton
						style={{
							backgroundColor: "#e67e22 ",
							":hover": {
								backgroundColor: "#ca6f1e",
							},
							":active": {
								backgroundColor: "#ca6f1e",
							},
						}}
						text="Ré-ouvrir"
						onClick={async (e) => {
							if (e !== undefined) e.preventDefault();
							await openFolder(folder.id);
							selectPatient(folder);
						}}
					/>
				)}
				{folder && folder.status !== "HELP_NURSE" && folder.openedBy && (
					<Popup
						content={`Dossier en cours de visualisation par ${folder.openedBy.first_name} ${folder.openedBy.last_name}.  Impossible d'ouvrir ce dossier en même temps qu'un autre utilisateur`}
						position="bottom center"
						trigger={
							<Label as="span">
								<Icon name="lock" /> {folder.openedBy.first_name} {folder.openedBy.last_name}
							</Label>
						}
					/>
				)}
				{folder && folder.status !== "HELP_NURSE" && !folder.openedBy && !folder.is_express && (
					<MainButton
						text="Voir"
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							if (folderHasNewTubes(folder) && showIdentityVigilancePopUp) {
								showIdentityVigilancePopUp(labAppointment.patient, () => selectPatient(folder));
							} else {
								selectPatient(folder);
							}
						}}
					/>
				)}
				{folder && folder.status === "HELP_NURSE" && folder.paused_at && (
					<MainButton
						text={user?.session?.role === "NURSE" ? "Prélever" : "Voir"}
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							doneFolderHelp(folder.id).then(async () => {
								selectPatient(folder);
							});
						}}
					/>
				)}
				{folder && folder.status === "HELP_NURSE" && !folder.paused_at && (
					<Label as="span" color="orange">
						Télésecrétariat
					</Label>
				)}
				{folder && hasScans && (
					<MainButton
						style={{
							backgroundColor: "#e67e22 ",
							":hover": {
								backgroundColor: "#ca6f1e",
							},
							":active": {
								backgroundColor: "#ca6f1e",
							},
						}}
						text={<Icon name="file alternate" aria-label={"Voir les documents"} />}
						onClick={(e) => {
							if (e) e.preventDefault();
							setShowScansModal(true);
						}}
					/>
				)}
			</Grid.Column>
			{folder && hasScans && showScansModal && (
				<PrescriptionsDocumentViewerMemo
					open={showScansModal}
					folder={folder}
					onClose={closeDocumentViewer}
					onFolderOpen={() => selectPatient(folder)}
					prescriptions={folderMemo.prescriptions.filter((pr) => pr.hasScans)}
					getAllPrescriptionScans={getAllPrescriptionScans}
				/>
			)}
		</Grid.Row>
	);
};

export default FolderCard;
